<template>
  <div
    v-if="rightNavActiveTab"
    class="right-presentation"
    :class="{
      'mobile-active': $store.state.activeModelDetailSlide,
      'show-grid': showingSlideGrid,
      'powerpoint': isEnableAddinPowerpoint,
      'open-edit': isOpenEditSlidePowerPoint,
      'hidden': !rightNavActiveTab,
    }"
    @mouseup.stop
  >
    <!-- Use mouseup.stop to prevent SideLeft/deselectAllSlides function listens to MouseEvent('mouseup'). -->
    <!-- <SyncLoadingAndMobileTurnOffTabContent v-if="$store.state.activeModelDetailSlide" /> -->
    <ContentTemplateThumbnail
      v-if="currentUser.email === 'template@ahaslides.com' && slideActive.type === 'freestyle'"
    />
    <div
      class="content-right-presentation"
      :class="{'disabled': isAudioTabDisabled}"
    >
      <div v-if="!canEditPresentation" class="overlay-disable-edit"></div>
      <div class="content-edit-panel__content">
        <div
          v-if="slideActive.activeTab == 1 && isContentTabActive"
          class="tab-content-presentation"
        >
          <SlideTypeList wrapperId="right-side" class="pt-3" />
        </div>
        <VideoTutorial v-if="isShowVideoTutorial" />
        <ContentTab v-if="showContentEditTab" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import Constant from '@/constant'
import Config from '@/config'
import ContentTab from '@/components-v2/presentation-editor/side-right/ContentTab.vue'
// import SyncLoadingAndMobileTurnOffTabContent from '@/components-v2/presentation-editor/side-right/SyncLoadingAndMobileTurnOffTabContent.vue'

import imageSubmissionTooltipImage from '@/assets/images/feature-update/image-submission-feature-update.svg'
import pollTooltipVideo from '@/assets/images/feature-update/poll.webm'
import VideoTutorial from '@/components-v2/presentation-editor/side-right/VideoTutorial.vue'
import ContentTemplateThumbnail from '@/components-v2/presentation-editor/side-right/ContentTemplateThumbnail'
import SlideTypeList from '@/components-v2/presentation-editor/new-slide/SlideTypeList.vue'

const noAudioTypes = new Set(Constant.slideTypesNoAudio)

export default {
  components: {
    ContentTab,
    // SyncLoadingAndMobileTurnOffTabContent,
    VideoTutorial,
    ContentTemplateThumbnail,
    SlideTypeList,
  },
  props: {
    showingAudioTab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTab: 1,
      envProduction: false,
      imageSubmissionTooltipImage,
      pollTooltipVideo,
    }
  },
  computed: {
    ...mapGetters('rightNav', ['rightNavTabNames', 'rightNavActiveTab', 'isStaticTab', 'isDesignTabActive', 'isAudioTabActive', 'isContentTabActive']),
    ...mapGetters('slideType', ['isSlideTypeNoAudio']),
    ...mapGetters(['isPresenting', 'selectedSlide']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      showingSlideGrid: (state) => state.indicators.showingSlideGrid,
      selectedSlideIds: (state) => state.selections.selectedSlideIds,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      canEditPresentation: (state) => state.canEditPresentation,
      currentUser: (state) => state.currentUser,
      isShowVideoTutorial() {
        const { videoTutorialUrl } = this.slideActive.typeObj || {}
        const excludedTabs = [this.rightNavTabNames.AUDIO, this.rightNavTabNames.SETTINGS]
        const canShowTutorialForCurrentTab = !excludedTabs.includes(this.rightNavActiveTab)

        return !!videoTutorialUrl && canShowTutorialForCurrentTab
      },
      presentation: (state) => state.presentation,
      presenterLocale: (state) => state.presenterLocale,
      slideGenerator: (state) => state.slideGenerator,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
      isOpenEditSlidePowerPoint: (state) => state.isOpenEditSlidePowerPoint,
      integrationPlatform: (state) => state.integrationPlatform,
    }),
    isLangFr() {
      return this.presenterLocale === Constant.presenterLanguage.fr
    },
    isEURegion() {
      return Config.region === Constant.euRegion
    },
    isAudioTabDisabled() {
      return this.isAudioTabActive && this.isSlideTypeNoAudio
    },
    showContentEditTab() {
      if (this.integrationPlatform === 'GoogleSlide') {
        return this.slideActive.activeTab == 2 && this.isContentTabActive
      }
      return this.slideActive.activeTab == 2 && this.isContentTabActive && !this.isPresenting
    },
  },
  watch: {
    selectedSlideIds() {
      setTimeout(() => {
        const isSelectingMultipleSlides = this.selectedSlideIds && this.selectedSlideIds.length > 1
        const hasNoAudioSlideSelected = noAudioTypes.has(this.selectedSlide.type)

        if (!isSelectingMultipleSlides) return
        if (this.activeTab < 3) {
          this.setRightNavActiveTabAction(this.rightNavTabNames.DESIGN)
        }
        if (hasNoAudioSlideSelected && this.rightNavActiveTab === this.rightNavTabNames.AUDIO) {
          this.setRightNavActiveTabAction(this.rightNavTabNames.CONTENT)
        }
      }, 200)
    },
  },

  methods: {
    ...mapActions('rightNav', ['setRightNavActiveTabAction']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variable.scss';
@import '@/assets/scss-v2/variables.scss';

.right-presentation {
  @apply mb-3 h-full;

  .content-right-presentation {
    position: relative;
    padding-bottom: 0;
    height: calc(100% - 56px); // .tab-content-presentation padding-bottom = 50px + 6px to fix height
    transform: scale(1); // to make right-panel-container__header fixed and follow this parent
    &.disabled {
      @apply cursor-not-allowed;
    }
  }
  &.powerpoint {
    width: 373px;
    position: absolute;
    right: -373px;
    top: 0;
    transition: ease-in-out 0.2s;

    &.open-edit {
      right: 0;
      z-index: 10;
    }
  }
}

.tab-content-presentation {
  padding: 15px 16px 50px;
  position: relative;
  z-index: 7; // https://ahaslides.atlassian.net/browse/AHA-14039
  &::v-deep {
    .slide-generator {
      .flex {
        display: flex !important; // overwrite CSS bootstrap
      }
    }
    .quiz-header-inner__title {
      @apply hidden;
    }
    .search-result {
      height: 70vh;
      margin-bottom: 0;
      .search-result-inner {
        height: 91%;
      }
    }
    .aha-link.aha-link--primary {
      color: #348EF6 !important; // text-primary-90
      &:hover, &:active {
        color: #257ADC !important; // text-primary-100
      }
    }
  }
}

.overlay-disable-edit {
  @apply bg-base-0 opacity-50 absolute left-0 top-0 w-full h-full;
  z-index: 9;
}
.right-panel-container__header {
  @apply border-b border-base-30 pb-0 px-4 fixed bg-base-0 z-10;
  top: -$right-panel-header-height;
  width: 382px;
  height: $right-panel-header-height;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  &.is-static-header {
    align-items: center;
    .right-panel-container__close-button {
      margin-bottom: 0;
    }
  }
}

.right-panel-container__close-button {
  @apply text-base-70 hover:text-primary-90;
  @apply cursor-pointer;
  margin-bottom: 1.2rem;
}
.content-edit-panel__content {
  margin-top: $right-panel-header-height;
  height: 100%;
  overflow-y: auto;
}
</style>
